import React from 'react'
import SearchBar from './SearchBar'
import Liste from './Liste'
import { Box, Typography } from '@mui/material'
import Title from '../components/Title'
import DialogAdd from './Add'

export default function Etablissement() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>

            <Box style={{ display: "flex", justifyContent: "space-between" }} >
                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Etablisement'
                />
                {/*---------------- fin titre --------------*/}

                {/*---------------- debut add --------------*/}
                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>
                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}
                <Box>
                    <DialogAdd />
                </Box>
                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <Liste />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
